<style lang="scss">
    .song-page {
        min-height: 100vh;
        .bg-image-overlay {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-image: linear-gradient(180deg, rgba(255, 255, 255, -0.5) 0%, #ffffff 100%);
            z-index: 1;
        }
        .bg-image {
            position: absolute;
            z-index: 0;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border: 0;
            height: 50%;
            background-repeat: no-repeat;
            background-position: center top;
            background-size: cover;
            opacity: 0.4;
            filter: blur(3px);
        }
        .bg-image-gradient {
            position: absolute;
            bottom: 0;
            height: 50%;
            width: 100%;
            background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
            background-repeat: repeat-x;
        }

        .item {
            display: flex;
            z-index: 10;
            .left-col {
                flex: 1;
                .item-image-wrapper {
                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.16);
                    border-radius: 5px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .right-col {
                flex: 2;
                padding-left: 30px;
            }
            .share-button, .song-description {
                color: #595e63;
            }
            .song-description {
                padding: 20px 0;
            }
            .page-title {
                h1 {
                    font-size: 30px;
                }
            }
            .buy-wrapper {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-top: 20px;
                .price {
                    font-size: 30px;
                    color: #ff1466;
                    font-weight: 600;
                }
            }

            .play-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px 0;
                cursor: pointer;
                background: #ffffff;
                .play-text {
                    font-size: 19px;
                    padding-left: 10px;
                }
            }
            .btn-playpause {
                background: #ff5b94;
                border-color: #ff5b94;
                color: #fff;
                position: absolute;
                top: 3px;
                left: 3px;
                padding: 0 0px;
            }

            .quarter {
                width: 23px;
                height: 23px;
                background-color: #ff5b94;
                opacity: 0.52;
            }

            .top-right {
                border-top-right-radius: 24px;
                border-bottom-right-radius: 3px;
                border-top-left-radius: 3px;
                position: absolute;
                right: 0;
                top: 0;
            }

            .bottom-left {
                border-bottom-left-radius: 40px;
                position: absolute;
                border-top-left-radius: 3px;
                border-bottom-right-radius: 3px;
                bottom: 0;
                left: 0;
            }

            #circle-container {
                width: 46px;
                height: 46px;
                position:relative;
                z-index:1;
            }
        }

        .general-info-wrapper {
            font-size: 14px;
            color: #595E63;
        }
        .general-info-item {
            padding: 10px 0;
            display: flex;
        }
        .general-info-title {
            color: #FF5B94;
            font-weight: 600;
            font-size: 20px;
        }
        .general-info-heading {
            min-width: 150px;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
            svg {
                font-size: 13px;
            }
        }
        .general-info-value {
            display: flex;
            flex-wrap: wrap;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
        }
        .download-button {
            color: #00d38a;
            float: right;
            margin-right: 10px;
            font-size: 20px;
        }

        @media screen and (max-width: 768px) {
            .item {
                .right-col {
                    padding-left: 10px;
                }
                .play-wrapper {
                    .play-text {
                        font-size: 16px;
                        padding-left: 5px;
                    }
                }
                .buy-wrapper {
                    .price {
                        font-size: 26px;
                    }
                }
            }
        }

        @media screen and (max-width: 500px) {
            .item {
                display: block;
                .right-col {
                    padding-left: 0;
                    padding-top: 20px;
                }
                .page-title {
                    h1 {
                        font-size: 22px;
                    }
                }
                .play-wrapper {
                    .play-text {
                        padding-left: 10px;
                    }
                }
                .buy-wrapper {
                    text-align: center;
                    .price {
                        display: block;
                    }
                }
            }
        }
    }
</style>

<template>
    <div v-if="song" class="song-page padding">
        <div class="bg-image-overlay" :style="$pageBackgroundOverlay"></div>
        <div class="bg-image" :style="{'background-image': 'url(' +  song.image(600) + ')'}">
            <div class="bg-image-gradient" :style="$pageBackgroundOverlay"></div>
        </div>

        <div class="item">
            <div class="left-col">
                <div class="item-image-wrapper">
                    <img :src="songImage">
                    <div class="play-wrapper" @click="play()" :style="$mainBodyStyle">
                        <div id="circle-container">
                            <div class="quarter top-right" :style="$playButtonStandalone"></div>
                            <div class="quarter bottom-left" :style="$playButtonStandalone"></div>
                            <button v-if="isPlaying == true" class="btn-playpause" :style="$playButtonStandalone">
                                <font-awesome-icon icon="pause"></font-awesome-icon>
                            </button>

                            <button v-else class="btn-playpause" :style="$playButtonStandalone">
                                <font-awesome-icon icon="play"></font-awesome-icon>
                            </button>
                        </div>
                        <span class="play-text" :style="$highlightColor">Play</span>
                    </div>
                </div>
            </div>

            <div class="right-col">
                <div class="page-title">
                    <h1 class="inline" :style="$mainPrimaryTextStyle">{{song.name}}</h1>
                    <div class="pull-right" :style="$mainSecondaryTextStyle"><share-button :item="song"></share-button></div>
                </div>

                <div :style="$highlightColor" class="general-info-title">GENERAL INFO</div>
                <div :style="$mainSecondaryTextStyle" class="general-info-wrapper">
                    <div class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="clock"></font-awesome-icon> Duration</div>
                        <div class="general-info-value">{{song.duration}}</div>
                    </div>
                    <div class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="compact-disc"></font-awesome-icon> Genre</div>
                        <div class="general-info-value">{{song.genre.name}}</div>
                    </div>
                </div>

                <div :style="$dividerStyle"></div>

                <div class="buy-wrapper">
                    <template v-if="song.price > 0">
                        <span :style="$buyPriceStyle()" class="price">{{song.price | displayPrice}}</span>
                        <button class="c-button c-button--default " :class="{'c-button--outline': song.inCart()}" @click="song.addToCart()">
                            <font-awesome-icon class="c-button__left-icon" :icon="song.inCart() ? 'shopping-cart' : 'cart-plus'"></font-awesome-icon>
                            <span v-if="song.inCart()">In cart</span>
                            <span v-else>Add To Cart</span>
                        </button>
                    </template>
                    <template v-else-if="song.freeDownload">
                        <download-button :item="song"></download-button>
                    </template>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Song from './../../models/song'
    import Playlist from './../../classes/playlist'
    import Configure from './../../mixins/configure'
    import SongRepository from './../../mixins/song-repository'

    import ShareButton from './../sharebutton.vue'
    import DownloadButton from './../downloadbutton.vue'

    export default {
        props: ['pageId'],
        created() {
            if (this.$route.params.song == undefined) {
                this.$router.push('/')
            }
            this.getSong(this.$route.params.song)
        },
        components: {
            ShareButton, DownloadButton
        },
        data() {
            return {
                song: false
            }
        },
        computed: {
            playerActive() {
                return this.$store.state.player.playing
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            isPlaying() {

                return (this.playlistManager.isPlaying(this.song) && this.playerActive)
            },
            isPaused() {
                return (this.playlistManager.isPlaying(this.song) && !this.playerActive)
            },
            songImage() {
                if (this.song) {
                    return (this.$store.state.viewPortWidth > 500) ? this.song.image(300) : this.song.image(600)
                }
            }
        },
        mixins: [Configure, SongRepository],
        methods: {
            getSong(id) {
                this.getUserSong(id)
                    .then((response) => {
                        this.song = new Song(response.data.item)
                        this.$store.commit("singleMusicPageName", {name: this.song.name})

                        this.$store.state.playlistManager.setPagePlaylist(new Playlist([this.song], "song-" + this.song.id, "song-" + this.song.id));

                    })
                    .catch(() => {
                        this.$router.push({path: '/'})
                    })
            },
            play() {
                if (this.isPlaying) {
                    this.song.pause()
                } else {
                    this.song.play()
                }
            }
        }

    }
</script>